// extracted by mini-css-extract-plugin
export default {"content":"ComprovanteDePagamento_content__z2UU0","th_tr_Responsive":"ComprovanteDePagamento_th_tr_Responsive__mXXt-"};